import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/oto/logo/flat/oto_logo_flat_small.png';
import _imports_1 from '@/assets/img/oto/logo/flat/oto_logo_flat_smile.png';
const _withScopeId = n => (_pushScopeId("data-v-521f3cdc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "logo-container" };
const _hoisted_2 = {
    key: "small",
    src: _imports_0,
    alt: "Oto logo",
    title: "oto"
};
const _hoisted_3 = {
    key: "large",
    src: _imports_1,
    alt: "Oto logo",
    title: "oto"
};
import { computed } from 'vue';
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    __name: 'HeaderLogo',
    props: {
        collapsedSidebar: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const getDefaultRoute = computed(() => store.getters.getDefaultRoute || '/');
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_router_link, { to: getDefaultRoute.value }, {
                    default: _withCtx(() => [
                        _createVNode(_Transition, {
                            name: "slide",
                            mode: "out-in"
                        }, {
                            default: _withCtx(() => [
                                (props.collapsedSidebar)
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_3))
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["to"])
            ]));
        };
    }
});
